import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Alert, Button } from '@grandvisionhq/common';
import { Heading, Hr, Text } from '@grandvisionhq/elements';
import { Containers } from '@grandvisionhq/stores-v2';
import AppointmentConfirmationInstructionsContainer from '../AppointmentConfirmationInstructions/AppointmentConfirmationInstructionsContainer.js';
import AppointmentOverviewContainer from '../AppointmentOverview/AppointmentOverviewContainer.js';
import { AppointmentProduct } from '../AppointmentProducts/AppointmentProduct.js';
import AppointmentSurvey from '../AppointmentSurvey/AppointmentSurveyContainer.js';
import ICSButton from '../ICSButton/ICSButton.js';
import StoreOverviewContainer from '../StoreOverview/StoreOverviewContainer.js';
import UserInfoOverviewContainer from '../UserInfoOverview/UserInfoOverviewContainer.js';

const StoreOffers = Containers.StoreOffers;
const AppointmentConfirmation = ({ className , labels , store , offers , type , timeSlot , appointment , tryInStoreProducts , googleMapsApiKey , storesUrl , directionsUrl , appointmentConfirmationContent , offerFallbackImageUrl , isVirtualAppointmentType , onICSButtonClick ,  })=>{
    var ref, ref1, ref2, ref3;
     return React.createElement("main", {
        className: classnames('appointment-confirmation', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "appointment-confirmation__headings"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__heading",
        component: "h2",
        variant: "small"
    }, labels.heading), /*#__PURE__*/ React.createElement(Hr, {
        className: "appointment-confirmation__horizontal-rule"
    }), labels.subHeading && /*#__PURE__*/ React.createElement("p", {
        className: "appointment-confirmation__sub-heading"
    }, labels.subHeading)), /*#__PURE__*/ React.createElement(Alert, {
        icon: "checkmark-circle",
        type: "success",
        message: /*#__PURE__*/ React.createElement("b", null, labels.notification),
        className: "appointment-confirmation__alert"
    }), tryInStoreProducts ? /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__try-in-store"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.tryInStoreProducts), tryInStoreProducts.map((product, i)=>/*#__PURE__*/ React.createElement(AppointmentProduct, {
            key: i,
            product: product
        })
    ), /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-confirmation__try-in-store-disclaimer",
        color: "text-secondary"
    }, labels.tryInStoreProductsDisclaimer)) : null, /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__appointment"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.appointment), /*#__PURE__*/ React.createElement(AppointmentOverviewContainer, {
        className: "appointment-confirmation__section-content appointment-confirmation__appointment_overview",
        appointment: swcHelpers.objectSpread({}, appointment, {
            invitee: undefined,
            child: undefined
        })
    }), !appointment.isReservation && /*#__PURE__*/ React.createElement(ICSButton, {
        className: "appointment-confirmation__button",
        caption: labels.addToCalendar,
        appointmentType: type,
        timeSlot: timeSlot,
        store: store,
        variant: "outline",
        onClick: onICSButtonClick
    })), /*#__PURE__*/ React.createElement(AppointmentSurvey, null), !isVirtualAppointmentType && /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__where"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.where), googleMapsApiKey && storesUrl && /*#__PURE__*/ React.createElement(StoreOverviewContainer, {
        className: "appointment-confirmation__section-content",
        store: store,
        googleMapsApiKey: googleMapsApiKey,
        storesUrl: storesUrl
    }), directionsUrl && /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-confirmation__button",
        variant: "outline",
        hrefTarget: "_blank",
        href: directionsUrl,
        caption: labels.getDirections
    })), !appointment.isReservation && appointmentConfirmationContent && /*#__PURE__*/ React.createElement(AppointmentConfirmationInstructionsContainer, {
        confirmationContent: appointmentConfirmationContent
    }), /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__who"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.who), /*#__PURE__*/ React.createElement(UserInfoOverviewContainer, {
        className: "appointment-confirmation__section-content",
        user: {
            firstName: (ref = appointment.invitee) === null || ref === void 0 ? void 0 : ref.firstName,
            lastName: (ref1 = appointment.invitee) === null || ref1 === void 0 ? void 0 : ref1.lastName,
            email: (ref2 = appointment.invitee) === null || ref2 === void 0 ? void 0 : ref2.email,
            phone: (ref3 = appointment.invitee) === null || ref3 === void 0 ? void 0 : ref3.phone,
            child: appointment.child
        }
    })), !appointment.isReservation && /*#__PURE__*/ React.createElement("section", {
        className: "appointment-confirmation__section appointment-confirmation__cant-make-it"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-confirmation__section-heading",
        variant: "smallest"
    }, labels.cantMakeIt), /*#__PURE__*/ React.createElement("p", {
        className: "appointment-confirmation__section-content appointment-confirmation__cancel-or-reschedule"
    }, labels.cancelOrReschedule)), !appointment.isReservation && offers && offers.length > 0 && /*#__PURE__*/ React.createElement(StoreOffers, {
        className: "appointment-confirmation__store-offers",
        fallbackImage: offerFallbackImageUrl,
        offers: offers,
        linkTarget: "_blank"
    }), /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-confirmation__button",
        variant: "outline",
        hrefTarget: "_blank",
        href: "/",
        caption: labels.exploreProducts
    }));
};
var AppointmentConfirmation$1 = AppointmentConfirmation;

export { AppointmentConfirmation$1 as default };
//# sourceMappingURL=AppointmentConfirmation.js.map
